import React, { useState } from 'react';
import { ChevronRight, Users, Building2, TrendingUp } from 'lucide-react';
import { useI18n } from '../hooks/useI18n';
import { getFileUrl } from '../utils/assetUrlHelper';

export default function DirectorDesk({ director = {} }) {
  const { t } = useI18n();
  const [isExpanded, setIsExpanded] = useState(false);

  const message = director.message || "Central Institute for Subtropical Horticulture Institute with a unique distinction of working on the mango the king of fruit on one hand and guava the poor man's apple on the other is placed on envious pedestal of having the world largest germplasm (755) in its field genebank. Being ever commi...";
  const shortMessage = message.length > 300 ? message.substring(0, 300) + '...' : message;

  // Use real director photo if available
  const directorPhoto = getFileUrl(director.photo_url) || '/images/director.jpeg';

  return (
    <section id="directorsSection" className="mb-6 md:mb-12" data-testid="director-desk">
      <div className="container-cish">
        <div className="flex flex-col lg:flex-row gap-4 md:gap-8 items-start">
          {/* Director photo - Optimized for Desktop and Tablet */}
          <div className="flex justify-center lg:justify-start w-full lg:w-auto order-first lg:order-last flex-shrink-0">
            <div className="relative">
              <img
                src={directorPhoto}
                alt={director.name || 'Director ICAR-CISH'}
                className="object-cover object-top w-[180px] h-[220px] sm:w-[220px] sm:h-[260px] md:w-[280px] md:h-[340px] lg:w-[300px] lg:h-[360px] rounded-sm shadow-lg"
                loading="lazy"
              />
            </div>
          </div>
          
          {/* Text content */}
          <div className="flex-1">
            {/* Section heading - matches CISH */}
            <h2 className="flex items-center gap-2 text-green-700 font-bold text-base md:text-[22px] py-4 md:py-6 text-[#1B5E20]">
              <img src="/icons/torch-director.svg" alt="" className="w-4 h-4 md:w-5 md:h-5" aria-hidden="true" />
              FROM DIRECTOR'S DESK
            </h2>

            {/* Message text */}
            <p className="text-gray-600 text-xs md:text-[16px] leading-relaxed">
              {isExpanded ? message : shortMessage}
            </p>
            
            {/* See More link */}
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="text-green-700 font-semibold inline-flex items-center gap-1 text-xs md:text-base mt-3 hover:underline"
              data-testid="see-more-btn"
            >
              {isExpanded ? 'SEE LESS' : 'SEE MORE'}
              <span>→</span>
            </button>

            {/* Action buttons - matches CISH card style */}
            <div className="mt-6 md:mt-8">
              <div className="flex flex-col sm:flex-row sm:flex-wrap justify-start items-stretch gap-2 md:gap-3">
                <a href="/staff" className="w-full sm:w-auto">
                  <div className="flex items-center justify-center gap-2 shadow-sm cursor-pointer hover:shadow-md px-4 md:px-8 py-3 md:py-4 bg-white border border-gray-300 hover:bg-green-700 hover:text-white text-black transition-all duration-200">
                    <Users className="w-4 h-4 md:w-5 md:h-5" aria-hidden="true" />
                    <span className="font-semibold text-xs md:text-sm whitespace-nowrap">OUR TEAM</span>
                  </div>
                </a>
                <a href="/about" className="w-full sm:w-auto">
                  <div className="flex items-center justify-center gap-2 shadow-sm cursor-pointer hover:shadow-md px-4 md:px-8 py-3 md:py-4 bg-white border border-gray-300 hover:bg-green-700 hover:text-white text-black transition-all duration-200">
                    <Building2 className="w-4 h-4 md:w-5 md:h-5" aria-hidden="true" />
                    <span className="font-semibold text-xs md:text-sm whitespace-nowrap">OUR ORGANIZATION</span>
                  </div>
                </a>
                <div className="w-full sm:w-auto">
                  <div className="flex items-center justify-center gap-2 shadow-sm cursor-pointer hover:shadow-md px-4 md:px-8 py-3 md:py-4 bg-white border border-gray-300 hover:bg-green-700 hover:text-white text-black transition-all duration-200">
                    <TrendingUp className="w-4 h-4 md:w-5 md:h-5" aria-hidden="true" />
                    <span className="font-semibold text-xs md:text-sm whitespace-nowrap">OUR PERFORMANCE</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
